<template>
  <DialogLayout
    ref="alertDialog"
    :isError="alertIsError"
    :title="alertTitle"
    confirmBtnText="OK"
    btnAlign="center"
    @close="btnAction()"
    hideAction
    :maxWidth="500"
    disableCloseHide
  >
    <div class="d-flex flex-column align-center my-8">
      <div class="colorBlack--text subtitle-1" v-html="$t(alertMessage)"></div>
    </div>
  </DialogLayout>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import DialogLayout from '@/components/layout/DialogLayout.vue'
import { getDefaultPages } from '@/router/src/access';

export default {
  name: 'Alert',
  components: {
    DialogLayout,
  },
  setup() {
    return {}
  },
  computed: {
    ...mapState({
      alertTitle: state => state.AlertHelper.title,
      alertMessage: state => state.AlertHelper.message,
      alertIsError: state => state.AlertHelper.isError,
      returnLink: state => state.AlertHelper.returnLink,
    }),
    open() {
      return this.$store.state.AlertHelper.showDialog
    },
  },
  watch: {
    open(val) {
      if (this.$refs && this.$refs.alertDialog) {
        if (val) {
          this.$refs.alertDialog.show()
        } else {
          this.$refs.alertDialog.hide()
        }
      }
    },
  },
  methods: {
    ...mapActions(['closeAlert']),
    async btnAction() {
      let redirect = null
      if (this.alertMessage === 'message.noPermission') {
        const defaultPages = getDefaultPages(this.$config)
        const userType = this.gfGetUserType()
        if (this.$validate.DataValid(defaultPages[userType])) {
          redirect = { name: defaultPages[userType][0] }
        } else {
          redirect = { name: 'Login' }
        }
      }

      if (!redirect && this.$validate.DataValid(this.returnLink)) {
        if (typeof this.returnLink === 'string') {
          redirect = { name: this.returnLink }
        } else {
          if (this.$validate.DataValid(this.returnLink.reload) && this.returnLink.reload === true) {
            window.scrollTo(0, 0)
            this.$router.go()
          } else {
            redirect = this.returnLink
            if (redirect.reload !== undefined) {
              delete redirect.reload
            }
          }
        }
      }

      if (redirect) {
        if (redirect.name === 'Login' || redirect.name === 'StudentLogin') {
          const getUser = this.gfGetCurrentUserData()
          if (getUser && getUser.user_type === 'student') {
            redirect['name'] = 'StudentLogin'
            redirect['params'] = { username: getUser.username }
          } else {
            redirect['name'] = 'Login'
          }
          await this.gfRemoveUserCookies()
        }
        this.$router.replace(redirect)
      }

      this.closeAlert()
    },
  },
}
</script>
